module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chap-acw"
  }, [_c('a', {
    attrs: {
      "id": "a83"
    }
  }), _vm._v("General Acknowledgements")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _vm._v("I gratefully acknowledge the invaluable help of Bobby Gainher in editing the manuscript and saving me from many errors, and for my son’s computer expertise in preparing the maps.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_x"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c7da670","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/08_FM.vue
// module id = 75
// module chunks = 0